import PropTypes from "prop-types";
import {NavigationInternalPagesEnum, NavigationLinkTypesEnum} from "../enums";
import {updateOnBrandCssVariables} from "../utils/contrastColor.utility";
export const GetAppearancePropTypes = () =>
  PropTypes.shape({
    theme_color: PropTypes.string,
    background_color: PropTypes.string,
    prime_button_color: PropTypes.string,
    secondary_button_color: PropTypes.string,
    general_text_color: PropTypes.string,
    header_text_color: PropTypes.string,
    fixed_nav: PropTypes.bool,
    fixed_social_media: PropTypes.bool,
    image_shaping: PropTypes.number,
    font: PropTypes.string,
    titles_style: PropTypes.any,
    sub_titles_style: PropTypes.any,
    descriptions_style: PropTypes.any,
    login_background_color: PropTypes.string,
    login_background_media: PropTypes.any,
    show_secondary_logo: PropTypes.bool,
    is_transparent_menu: PropTypes.bool,
    drawer_text_color: PropTypes.string,
    show_ai_score: PropTypes.bool,
  });
export const GetSectionDataPropTypes = () =>
  PropTypes.shape({
    uuid: PropTypes.string,
    type: PropTypes.number,
    order: PropTypes.number,
    layout: PropTypes.number,
    language_uuid: PropTypes.string,
    is_hidden: PropTypes.bool,
    constants: PropTypes.shape({
      header_title: PropTypes.string,
      sub_header_title: PropTypes.string,
      background_color: PropTypes.string,
      background_media: PropTypes.shape({
        uuid: PropTypes.string,
        url: PropTypes.string,
      }),
    }),
    section_data: PropTypes.shape({
      description: PropTypes.string,
      action_title: PropTypes.string,
      has_call_to_action: PropTypes.bool,
      iframe_map: PropTypes.string,
      quotes: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          // .required(t(`${translationPath}quote-name-is-required`)),
          job_title: PropTypes.string,
          description: PropTypes.string,
          media: PropTypes.shape({
            uuid: PropTypes.string,
            url: PropTypes.string,
          }),
          social_media: PropTypes.shape({
            linkedin: PropTypes.string,
            facebook: PropTypes.string,
            youtube: PropTypes.string,
            twitter: PropTypes.string,
            snapchat: PropTypes.string,
            instagram: PropTypes.string,
            website: PropTypes.string,
          }),
        })
      ),
      stories: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          sub_title: PropTypes.string,
          description: PropTypes.string,
          media: PropTypes.shape({
            uuid: PropTypes.string,
            url: PropTypes.string,
          }),
        })
      ),
      categories: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          job_category_uuid: PropTypes.string,
          link_type: PropTypes.oneOf(
            Object.values(NavigationLinkTypesEnum).map((el) => el.key)
          ),
          link: PropTypes.string,
          pages: PropTypes.arrayOf(
            PropTypes.shape({
              title: PropTypes.string,
              link_type: PropTypes.oneOf(
                Object.values(NavigationLinkTypesEnum).map((el) => el.key)
              ),
              link: PropTypes.string,
            })
          ),
        })
      ),
      grids: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          sub_title: PropTypes.string,
          type: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          media: PropTypes.shape({
            uuid: PropTypes.string,
            url: PropTypes.string,
          }),
          description: PropTypes.string,
        })
      ),
      medias: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          description: PropTypes.string,
          media: PropTypes.shape({
            uuid: PropTypes.string,
            url: PropTypes.string,
          }),
        })
      ),
      partners: PropTypes.arrayOf(
        PropTypes.shape({
          partner_url: PropTypes.string,
          media: PropTypes.shape({
            uuid: PropTypes.string,
            url: PropTypes.string,
          }),
        })
      ),
      company_favicon: PropTypes.any,
      company_logo: PropTypes.shape({
        uuid: PropTypes.string,
        url: PropTypes.string,
        type: PropTypes.number,
      }),
      secondary_logo: PropTypes.shape({
        uuid: PropTypes.string,
        url: PropTypes.string,
        type: PropTypes.number,
      }),
      nav_items: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          type: PropTypes.number,
          link: PropTypes.string,
          nav_items: PropTypes.array,
        })
      ),
    }),
  }).isRequired;

export const GetLayoutPropTypes = () => ({
  company_uuid: PropTypes.shape({
    id: PropTypes.string,
    account_uuid: PropTypes.string,
    name: PropTypes.string,
    translate_languages: PropTypes.arrayOf(
      PropTypes.shape({
        code: PropTypes.string,
        visible: PropTypes.bool,
      })
    ),
  }),
  appearance: GetAppearancePropTypes(),
  languages: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string,
      language: PropTypes.shape({
        id: PropTypes.string,
        code: PropTypes.string,
        title: PropTypes.string,
      }),
      is_default: PropTypes.bool,
      is_published: PropTypes.bool,
    })
  ),
  social_medial: PropTypes.array,
  seo: PropTypes.shape({
    seo_title: PropTypes.string,
    seo_description: PropTypes.string,
    seo_keywords: PropTypes.string,
    seo_image: PropTypes.any,
  }),
  portal: PropTypes.arrayOf(GetSectionDataPropTypes()),
  country_code: PropTypes.string,
  candidate_signup_as_clone: PropTypes.bool,
  register_candidate: PropTypes.number,
  google_analytics: PropTypes.shape({
    enabled: PropTypes.bool,
    track_id: PropTypes.string,
  }),
  account: PropTypes.shape({
    uuid: PropTypes.string,
    name: PropTypes.objectOf(PropTypes.string),
    account_number: PropTypes.number,
    has_third_party: PropTypes.bool,
    currency: PropTypes.string,
  }),
  excluded_countries: PropTypes.arrayOf(PropTypes.string),
  has_nationality_setting: PropTypes.bool,
});

export const ThemeInit = (portalLayout) => {
  const {appearance} = portalLayout || {appearance: {}};

  document.documentElement.style.setProperty(
    "--primary",
    appearance?.theme_color || "#051274"
  );
  document.documentElement.style.setProperty(
    "--background-color",
    appearance?.background_color || "#051274"
  );
  document.documentElement.style.setProperty(
    "--primary-button",
    appearance?.prime_button_color || "transparent"
  );
  document.documentElement.style.setProperty(
    "--secondary-button",
    appearance?.secondary_button_color || "transparent"
  );
  document.documentElement.style.setProperty(
    "--header_text_color",
    appearance?.header_text_color || "#ffffff"
  );
  document.documentElement.style.setProperty(
    "--general_text_color",
    appearance?.general_text_color || "#000000"
  );
  document.documentElement.style.setProperty(
    "--custom-font",
    appearance?.font || "Cairo-Regular"
  );
  document.documentElement.style.setProperty(
    "--drawer_text_color",
    appearance?.drawer_text_color || "#fff"
  );
  updateOnBrandCssVariables();
};

export const GetInternalPage = (type) => {
    let linkPath;
    switch (type) {
        case NavigationInternalPagesEnum.Home.key:
            linkPath = NavigationInternalPagesEnum.Home.value;
            break;

        case NavigationInternalPagesEnum.Profile.key:
            linkPath = NavigationInternalPagesEnum.Profile.value;
            break;

        case NavigationInternalPagesEnum.Jobs.key:
            linkPath = NavigationInternalPagesEnum.Jobs.value;
            break;

        case NavigationInternalPagesEnum.Applications.key:
            linkPath = NavigationInternalPagesEnum.Applications.value;
            break;

        case NavigationInternalPagesEnum.Interviews.key:
            linkPath = NavigationInternalPagesEnum.Interviews.value;
            break;

        default:
            linkPath = "/Home/self-service";
    }

    return linkPath;
};

export const ScrollToItem = (id) => {
    // eslint-disable-next-line no-debugger
    debugger;
    const element = document.getElementById(id);
    if (element) {
        element.scrollIntoView({behavior: "smooth", block: "start"});
    }
};
